import eventsAICamera from "./eventsAICamera.svg";
import eventsEnvSensor from "./eventsEnvSensor.svg";
import eventsFloodSensor from "./eventsFloodSensor.svg";
import alertsAICamera from "./alertsAICamera.svg";
import alertsEnvSensor from "./alertsEnvSensor.svg";
import alertsFloodSensor from "./alertsFloodSensor.svg";
import operationsAICamera from "./operationsAICamera.svg";
import operationsEnvSensor from "./operationsEnvSensor.svg";
import operationsFloodSensor from "./operationsFloodSensor.svg";

export default {
  eventsAICamera,
  eventsEnvSensor,
  eventsFloodSensor,
  alertsAICamera,
  alertsEnvSensor,
  alertsFloodSensor,
  operationsAICamera,
  operationsEnvSensor,
  operationsFloodSensor,
};
